import { combineEpics } from 'redux-observable'
import createAudioTrack$, { createLocalAudioTrackError$, createLocalAudioTrackTimeout$ } from './createAudioTrack'
import createVideoTrack$ from './createVideoTrack'
import selectDeviceChanges$ from './selectedDeviceChanges'
import audioSourceChange$ from './audioSourceChange'

export default combineEpics(
  createAudioTrack$,
  createVideoTrack$,
  createLocalAudioTrackError$,
  createLocalAudioTrackTimeout$,
  selectDeviceChanges$,
  audioSourceChange$
)
